import { RECEIVE_PROPERTY_INCOME_SUMMARY, REQUEST_PROPERTY_INCOME_SUMMARY } from '../actions'

export default (
    state = {
        fetchSuccessful: null,
        isFetching: false,
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_PROPERTY_INCOME_SUMMARY:
            return { ...state, isFetching: true, shouldFetch: false }

        case RECEIVE_PROPERTY_INCOME_SUMMARY: {
            return { ...state, ...data, isFetching: false }
        }

        default:
            return state
    }
}
